import { MdCurrencyExchange } from 'react-icons/md';

import { StepProps, StepsIds } from '../../types';
import Button, { ButtonType } from 'legacy/common/components/button/Button';

const TransferredOptions = ({ goToStep }: StepProps) => (
  <div className="p-4 flex flex-col gap-4">
    <Button
      type={ButtonType.Outline}
      onClick={() => goToStep(StepsIds.ConfirmRevokeStep)}
      icon={<MdCurrencyExchange className="text-red-800" size={18} />}
    >
      <span className="text-red-800">Revoke Ticket</span>
    </Button>
  </div>
);

export default TransferredOptions;
